import {stringifyId} from '../types'
import type {BuildTypeId, ChangeId, ProjectId} from '../types'

type Params = {
  text: string | null | undefined
  projectId?: ProjectId | null | undefined
  buildTypeId?: BuildTypeId | null | undefined
  changeId?: ChangeId | null | undefined
  personal?: boolean
}
export default ({
  text,
  projectId,
  buildTypeId,
  changeId,
  personal,
}: Params): string | null | undefined => {
  if (text == null) {
    return null
  }

  const params = new URLSearchParams()
  params.set('content', text)

  if (projectId != null) {
    params.set('projectId', stringifyId(projectId))
  }
  if (buildTypeId != null) {
    params.set('buildTypeId', stringifyId(buildTypeId))
  } else if (changeId != null && personal != null) {
    params.set('modId', stringifyId(changeId))
    params.set('personal', String(personal || false))
  }

  return `bsout.html?${params.toString()}`
}
